module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Bold.7c21a451.ttf";